import m from 'mithril'
import "./statusbar.css"

var statusMessage;
var statusTimeout;
var statusVisible = false;

document.setStatus = function(message, duration = 1000) {
  console.info("Status:", message)
  statusMessage = message
  statusVisible = true;
  clearTimeout(this.statusTimeout);
  this.statusTimeout = setTimeout(function() {
      statusMessage = undefined;
      statusVisible = false;
      m.redraw();
  }, duration);
  m.redraw();
}


var StatusBar = {
  view: function(vnode) {
    return m("div#statusbar", {class:statusVisible ? undefined : "hidden"},
      statusMessage || "-"
    )
  }
}




module.exports = StatusBar